import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CoreClass } from '@src/app/core/base/core.class';
import { passwordRegex } from '@src/app/core/constants';
import { ChangePassword } from '@src/app/core/models/v1/requests/change.password.request.model';
import { HelperService } from '@src/app/core/services';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  standalone:false,
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent extends CoreClass implements OnInit,OnDestroy {
  @Output() togglePassword = new EventEmitter<any>()
  @Output() changePassword = new EventEmitter<any>()
  @Input() heading: string | null = ''
  password_form: FormGroup;
  subscriber : any
  inputStyle = "background: rgba(239, 239, 239, 0.50);";
  constructor(private injector: Injector, private fb: FormBuilder,public helperService : HelperService) {
    super(injector);
    this.password_form = this.fb.group({
      oldPassword: [null, { validators: [Validators.required, Validators.pattern(passwordRegex)] }],
      newPassword: [null, { validators: [Validators.required, Validators.pattern(passwordRegex)] }],
      confirmPassword: [null, { validators: [Validators.required, this.comparePassword('newPassword')] }],
    })
  }
  ngOnInit(): void {
    this.subscriber = this.sharedService.resetPasswordForm.subscribe(
      (data : any) =>
      {
        this.password_form.reset()
      }
    )
  }
  ngOnDestroy(): void {
    this.subscriber.unsubscribe()
  }
  comparePassword(controlName: string): ValidatorFn {
    return (comparePasswordControl: AbstractControl): ValidationErrors | null => {
      const controlValue = this.password_form?.controls[controlName].value
      return controlValue === comparePasswordControl.value ? null : { passwordMismatch: true }
    }
  }
  updatePassword = (event : any) => {
    this.password_form.markAllAsTouched()
    if (this.password_form.valid) {
      // this.sharedService.addLoader(event)
      // const body = {
      //   "oldPassword": this.password_form.value.oldPassword,
      //   "newPassword": this.password_form.value.newPassword,
      //   'userName' : this.storageService.getUserInformation()?.userName
      // }

      let body  = this.password_form.value
      delete body.confirmPassword
      body = new ChangePassword({...body,'userName' : this.storageService.getUserInformation()?.userName}).data
      this.changePassword.emit(body)
    }
  }
}
